import { render } from "./AppTohumlar.vue?vue&type=template&id=032235d5&scoped=true"
import script from "./AppTohumlar.vue?vue&type=script&lang=js"
export * from "./AppTohumlar.vue?vue&type=script&lang=js"

import "./AppTohumlar.vue?vue&type=style&index=0&id=032235d5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-032235d5"]])

export default __exports__